/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { MessagesView } from '../messages/messages-view.js';

/** Parent → Messages (Figma). Chat with their children's therapists. */
export function ParentMessagesPage(): JSX.Element {
  return <MessagesView />;
}
